import { render, staticRenderFns } from "./PagePaymentStatus.vue?vue&type=template&id=4794c7ee&scoped=true&"
import script from "./PagePaymentStatus.vue?vue&type=script&lang=js&"
export * from "./PagePaymentStatus.vue?vue&type=script&lang=js&"
import style0 from "./PagePaymentStatus.vue?vue&type=style&index=0&id=4794c7ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4794c7ee",
  null
  
)

export default component.exports